import { createContext } from "react";

export interface ICallAssistantTourContext {
  currentStepTarget: string;
  startTour: () => void;
  isRunning: boolean;
}

export const CallAssistantTourContext =
  createContext<ICallAssistantTourContext | null>(null);
